export function SectionBanner({ title, variant = "gold", testid }) {
  const styles =
    variant === "red"
      ? "live-fx text-[#FFF8E7] border-[color:var(--accent-gold)]"
      : "bg-gradient-to-r from-[#F3C24B] via-[#FFD700] to-[#F3C24B] text-[#5A0A14] border-[#7A1020]";
  return (
    <div data-testid={testid} className={`mb-4 flex items-center justify-center gap-2 rounded-xl border-2 py-2.5 px-4 text-center shadow-[0_4px_14px_rgba(0,0,0,0.35)] ${styles}`}>
      <span className="text-base sm:text-lg font-display font-extrabold uppercase tracking-widest">
        ❰❰ {title} ❱❱
      </span>
    </div>
  );
}
